export type RealtimeAlarmDebugStage = 'alarm_enriched' | 'alarm_received' | 'message_received' | 'occurrence_created' | 'popup_enqueued' | 'tunnel_focus_applied';

const REALTIME_ALARM_DEBUG_STORAGE_KEY = 'sus:realtime-alarm-debug';

function isRealtimeAlarmDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(REALTIME_ALARM_DEBUG_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/** localStorage opt-in 상태에서만 occurrence 처리 구간별 시각을 구조화해 출력합니다. */
export function debugRealtimeAlarmStage(stage: RealtimeAlarmDebugStage, fields: Record<string, unknown>): void {
  if (!isRealtimeAlarmDebugEnabled()) return;
  console.debug('[realtime-alarm] 처리 단계', {
    ...fields,
    handled_at_ms: Date.now(),
    log_event: `realtime.alarm.${stage}`,
    log_type: 'realtime',
    protocol: 'sse',
    stage: 'CHECK',
  });
}
